(function () {
  'use strict';

  var sourceSelector = '[data-dbe-blog-commerce-source]';
  var moduleSelector = '[data-dbe-commerce-template-module]';

  function normalizeText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function insertAfter(anchor, node) {
    if (!anchor || !node || !anchor.parentNode) return false;
    anchor.parentNode.insertBefore(node, anchor.nextSibling);
    return true;
  }

  function headingLevel(heading) {
    return Number(String(heading && heading.tagName || '').replace('H', '')) || 6;
  }

  function directArticleChild(article, element) {
    var current = element;
    while (current && current.parentElement && current.parentElement !== article) {
      current = current.parentElement;
    }
    return current && current.parentElement === article ? current : null;
  }

  function findHeading(article, text) {
    var needle = normalizeText(text);
    if (!needle) return null;
    return Array.prototype.find.call(article.querySelectorAll('h2, h3'), function (heading) {
      return normalizeText(heading.textContent).indexOf(needle) !== -1;
    }) || null;
  }

  function insertAfterHeadingSection(article, heading, node) {
    if (!article || !heading || !node) return false;
    var contentBlock = directArticleChild(article, heading);
    if (!contentBlock) return false;
    if (contentBlock !== heading) return insertAfter(contentBlock, node);

    var level = headingLevel(heading);
    var cursor = heading.nextElementSibling;
    while (cursor) {
      if (/^H[1-6]$/.test(cursor.tagName) && headingLevel(cursor) <= level) {
        article.insertBefore(node, cursor);
        return true;
      }
      cursor = cursor.nextElementSibling;
    }
    article.appendChild(node);
    return true;
  }

  function fallbackMidHeading(article) {
    var headings = Array.prototype.slice.call(article.querySelectorAll('h2'));
    if (!headings.length) return null;
    return headings[Math.min(headings.length - 1, Math.max(0, Math.floor(headings.length * 0.45)))];
  }

  function faqHeading(article) {
    return Array.prototype.find.call(article.querySelectorAll('h2, h3'), function (heading) {
      return /frequently asked|\bfaqs?\b|buying questions/.test(normalizeText(heading.textContent));
    }) || null;
  }

  function directChildHeadings(container, tagName) {
    return Array.prototype.filter.call(container.children, function (element) {
      return element.tagName === tagName;
    });
  }

  function enhanceFaq(article) {
    var heading = faqHeading(article);
    if (!heading) return;

    var section = directArticleChild(article, heading);
    if (!section || section === heading || section.dataset.dbeCommerceFaqMounted === 'true') return;

    var questions = directChildHeadings(section, 'H3');
    if (!questions.length) return;

    section.dataset.dbeCommerceFaqMounted = 'true';
    section.classList.add('dbe-blog-commerce-faq');

    questions.forEach(function (question, index) {
      var details = document.createElement('details');
      var summary = document.createElement('summary');
      var answer = document.createElement('div');

      details.className = 'dbe-blog-commerce-faq__item';
      summary.className = 'dbe-blog-commerce-faq__question';
      answer.className = 'dbe-blog-commerce-faq__answer';
      details.open = index === 0;

      question.parentNode.insertBefore(details, question);
      summary.appendChild(question);
      details.appendChild(summary);

      while (details.nextSibling) {
        var next = details.nextSibling;
        if (next.nodeType === 1 && next.tagName === 'H3') break;
        answer.appendChild(next);
      }

      details.appendChild(answer);
    });
  }

  function mountSource(source) {
    if (!source || source.dataset.dbeCommerceMounted === 'true') return;

    var article = document.querySelector('#main-article .post-content');
    if (!article) return;

    source.dataset.dbeCommerceMounted = 'true';
    article.querySelectorAll(moduleSelector).forEach(function (existing) {
      existing.remove();
    });

    var topModule = source.querySelector('[data-blog-commerce-module="top_availability"]');
    var contextModule = source.querySelector('[data-blog-commerce-module="mid_context"]');
    var endModule = source.querySelector('[data-blog-commerce-module="end_matrix"]');

    var oldTop = article.querySelector('[data-blog-commerce-module="intro_shop"], [data-dbe-blog-cro="intro"]');
    var verdict = article.querySelector('[data-dbe-blog-cro="answer"]');
    var firstParagraph = Array.prototype.find.call(article.querySelectorAll('p'), function (paragraph) {
      return normalizeText(paragraph.textContent).length > 40;
    });
    if (topModule) {
      if (oldTop) oldTop.replaceWith(topModule);
      else if (!insertAfter(verdict || firstParagraph, topModule)) article.prepend(topModule);
    }

    var oldDecision = article.querySelector('[data-blog-commerce-module="review_decision"], [data-dbe-blog-cro="decision"]');
    var contextMarker = article.querySelector('[data-dbe-commerce-anchor="mid_context"]');
    var configuredMidHeading = findHeading(article, source.dataset.midAnchorHeading);
    var midHeading = configuredMidHeading || fallbackMidHeading(article);
    if (contextModule) {
      if (contextMarker) contextMarker.replaceWith(contextModule);
      else if (configuredMidHeading) {
        if (oldDecision) oldDecision.remove();
        insertAfterHeadingSection(article, configuredMidHeading, contextModule);
      }
      else if (oldDecision) oldDecision.replaceWith(contextModule);
      else if (!insertAfterHeadingSection(article, midHeading, contextModule)) article.appendChild(contextModule);
    }

    var oldFinal = article.querySelector('[data-blog-commerce-module="review_final"]');
    var endMarker = article.querySelector('[data-dbe-commerce-anchor="end_matrix"]');
    var configuredEndHeading = findHeading(article, source.dataset.endBeforeHeading);
    var endHeading = configuredEndHeading || faqHeading(article);
    if (endModule) {
      if (endMarker) endMarker.replaceWith(endModule);
      else if (configuredEndHeading) {
        if (oldFinal) oldFinal.remove();
        var configuredEndBlock = directArticleChild(article, configuredEndHeading);
        if (configuredEndBlock) article.insertBefore(endModule, configuredEndBlock);
        else article.appendChild(endModule);
      }
      else if (oldFinal) oldFinal.replaceWith(endModule);
      else if (endHeading) {
        var endBlock = directArticleChild(article, endHeading);
        if (endBlock) article.insertBefore(endModule, endBlock);
        else article.appendChild(endModule);
      }
      else article.appendChild(endModule);
    }

    enhanceFaq(article);

    if (!source.querySelector('.dbe-blog-commerce')) source.remove();
  }

  function mountAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(sourceSelector).forEach(mountSource);
  }

  mountAll(document);

  if (!window.__dbeBlogCommerceSectionListener) {
    window.__dbeBlogCommerceSectionListener = true;
    document.addEventListener('shopify:section:load', function (event) {
      mountAll(event.target || document);
    });
  }
})();
